import React from 'react';

import lazyGettext from 'js-utils/lazy-gettext';

import CheckMark from '../components/CheckMark';

export const TABLE_TITLE_SHORT = lazyGettext('Features');
export const AFTER_DOWNGRADE = lazyGettext('No price change');
export const KEEP_CURRENT = lazyGettext('Keep current package');
export const UPDATE_CTA = lazyGettext('Update to new Essentials');
export const CURRENT_PACKAGE = lazyGettext('Current package');
export const AFTER_UPDATE = lazyGettext('After update');
export const FEATURE_ONE = lazyGettext('Number of ticket types');
export const FEATURE_ONE_V1 = lazyGettext('One');
export const FEATURE_ONE_V2 = lazyGettext('Unlimited') + ' 🎉';
export const FEATURE_TWO = lazyGettext('Ticketing & registration essentials');
export const FEATURE_THREE = lazyGettext(
    'Listing on Eventbrite and partner sites',
);
export const FEATURE_FOUR = lazyGettext('Ticket sales on Facebook');
export const FEATURE_FIVE = lazyGettext('Email Campaigns');
export const FEATURE_SIX = lazyGettext('Distribution on partner web sites');
export const WARNING = lazyGettext(
    'You will not be able to switch back to your current package',
);
export const DESCRIPTION = lazyGettext(
    "Here's what's different in our new Essentials package",
);
export const HEADING = lazyGettext('Update to our new Essentials package');

export const UPDATE_BANNER_CTA = lazyGettext('Update Now');
export const UPDATE_BANNER_HEADING = lazyGettext(
    'A newer version of the Essentials package is available',
);

export const PACKAGE_UPDATE_HEADING = {
    heading: HEADING,
    description: DESCRIPTION,
};

export const PACKAGE_UPDATE_FEATURES = [
    {
        feature: FEATURE_ONE,
        currentPackage: FEATURE_ONE_V1,
        newPackage: FEATURE_ONE_V2,
    },
    {
        feature: FEATURE_TWO,
        currentPackage: <CheckMark />,
        newPackage: <CheckMark />,
    },
    {
        feature: FEATURE_THREE,
        currentPackage: <CheckMark />,
        newPackage: <CheckMark />,
    },
    {
        feature: FEATURE_FOUR,
        currentPackage: <CheckMark />,
        newPackage: null,
    },
    {
        feature: FEATURE_FIVE,
        currentPackage: <CheckMark />,
        newPackage: null,
    },
    {
        feature: FEATURE_SIX,
        currentPackage: <CheckMark />,
        newPackage: null,
    },
];

export const PACKAGE_UPDATE_BREADCRUMB = {
    path: '#',
    label: lazyGettext('Update Package'),
};
